import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { getForms } from "../../services/formsService";
import {
  formsPageState,
  formsState,
  loadingFormsState,
  searchFormsState,
  updateFormsState,
} from "../../storage/formStates";
import { FormCore } from "../../types/forms";
import { PaginatedProvider } from "./PaginatedProvider";

export function FormsProvider() {
  const updateForms = useRecoilValue(updateFormsState);
  const resetUpdateForms = useResetRecoilState(updateFormsState);
  const setPaginatedForms = useSetRecoilState(formsState);
  const setLoadingForms = useSetRecoilState(loadingFormsState);

  return (
    <PaginatedProvider<FormCore>
      searchState={searchFormsState}
      pageState={formsPageState}
      getPaginated={getForms}
      setPaginated={setPaginatedForms}
      onSearchChange={() => {
        // TODO: Do something if needed when search changes.
      }}
      onUpdateFinish={() => {
        resetUpdateForms();
      }}
      setLoading={setLoadingForms}
      update={updateForms}
    />
  );
}
